<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{mType == '2' ? '行政采购项目' : '人力资源项目'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/admin' : '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=${mType}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>项目支出详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <p> 
          <a class="linkwrap normal" @click="link(`/admin/view?id=${query.cid}&mType=${mType}`)">
            <el-link style="font-size: 16px !important;">{{ form.projectArr.contract_no ? form.projectArr.contract_no : '暂无' }} </el-link> <span>-</span> <span>{{ form.projectArr.contract_name }}</span>
          </a> 
        </p>
        <p>子项目：{{ form.projectSonArr.contract_name }}</p>
        <h1 style="margin-top: 16px;" v-if="form.vendorArr">{{ form.vendorArr.vendor }}</h1>
        <h1 style="margin-top: 16px;cursor: pointer;" v-else @click="showVendor">点击选择供应商</h1>
        <p>{{ form.service_type_name }}</p>
        <p class="info-detail" v-html="form.service_info"></p>
        <p v-if="Object.keys(form.customerProjectArr).length != 0"><a class="linkwrap normal" style="font-size: 16px !important; cursor: pointer;" @click="link(`/project/detail?id=${form.customerProjectArr.id}`)">关联项目：{{ form.customerProjectArr ? form.customerProjectArr.contract_name : '' }} <span v-if="Object.keys(form.customerProjectSonArr).length != 0"> - {{ form.customerProjectSonArr?.contract_name }}</span></a></p>
        <p v-if="Object.keys(form.customerUserArr).length != 0" class="pdou">关联员工：<span v-for="(item, index) in form.customerUserArr" :key="index"> {{ `${item.en_name} ${item.realname}` }} </span></p>
      </div>
      <div class="header-status">
        <div v-if="form.budget_status">
          <el-tooltip class="item" effect="dark"
            :content="(form.budget_status == '1' || form.budget_status == '2') ? '暂无' : (form.budget_status == '3' ? (form.budget_check_info ? form.budget_check_info : '暂无') : (form.budget_check_reason ? form.budget_check_reason : '暂无'))"
            placement="bottom-start">
            <div class="button" :style="{ 'backgroundColor': dd.budget_status_c[form.budget_status].color }">{{
              dd.budget_status_c[form.budget_status].word }}</div>
          </el-tooltip>
        </div>        
      </div>      
    </div>
    <!-- 采购信息 -->
    <div class="base1">
      <h3 class="ntitle">采购信息</h3>
      <div class="operater" v-if="proStatus != 5">
        <div class="linkline" @click="editBudget"  v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170'))">{{form.budget_status != '2' ? '编辑' : '预算审核中...'}}</div>
        <div class="linkbox"  @click="showBudgetCheck" v-if="(mType == '2' ? (NodeInclude('136') || NodeInclude('340')) : (NodeInclude('168') || NodeInclude('341'))) && form.budget_status != '3'">预算审核</div>
      </div>      
      <ul>
        <li>
          <p>
            <label>预算：</label><a>{{ form.budget }}</a>
          </p>
          <p>
            <label>服务说明：</label><a style="white-space: pre-wrap;">{{ form.service_info }}</a>
          </p>
          <p style="width: 150%;">
            <label>清单附件：</label>
            <template>
              <ul class="anlist">
                <li v-for="(item, index) in fileList" :key="index">
                  <div class="abox">
                    <!-- 选择文件 -->
                    <el-col :span="4" v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170')) && proStatus != 5">
                      <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                        :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                        :on-change="(arg) => uploadFileMtype(arg, 'fileList', 'upFile', item, index)">
                        <el-button size="small" style="width: 80px;">选择文件</el-button>
                      </el-upload>
                    </el-col>
                    <!-- 文件预览及下载 -->
                    <template v-if="item.origin_name">
                      <el-col :span="20">
                        <el-col :span="18">
                          <div class="origin-name">{{ item.origin_name }}</div>
                        </el-col>
                        <el-col :span="2">
                          <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                            target="_blank">查看</el-link>
                        </el-col>
                      </el-col>
                    </template>
                  </div>
                  <el-button class="bbtn" v-if="(index === 0) && (mType == '2' ? NodeInclude('134') : NodeInclude('170')) && proStatus != 5" icon="el-icon-plus"
                    @click="addImage(fileList)" circle></el-button>
                  <el-button class="bbtn" v-if="index > 0 && (mType == '2' ? NodeInclude('134') : NodeInclude('170')) && proStatus != 5" icon="el-icon-minus"
                    @click="removeImage(fileList, index)" circle></el-button>
                </li>
              </ul>
            </template>
          </p>
          <p v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170')) && proStatus != 5">
            <label></label>
            <a>
              <el-button type="primary" @click="updatePayFn" style="margin-top: 18px; ">确认上传</el-button>
            </a>
          </p>          
        </li>
        <li>
          <p>
            <label>选择支付类别：</label><a>{{ dd.pay_type[form.pay_type] }}</a>
          </p>
          <p>
            <label>服务类目：</label><a>{{ form.service_type_name }}</a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 供应商合同信息 -->
    <div class="base1">
      <h3 class="ntitle">供应商合同信息</h3>
      <div class="operater" v-if="form.vendorContractArr && proStatus != 5">
        <div class="linkline" @click="form.budget_status!= '2' && link(`/purchase/add?id=${form.vendorContractArr.id}&kind=1&vid=${form.vendorArr.id}&mType=${mType}`)" v-if="((!form.vendorContractArr.contract_no || form.vendorContractArr.contract_no == 'TBD') && (mType == '2' ? NodeInclude('148') : NodeInclude('178')) && is_apply == 1) || level == '1'">{{form.budget_status != '2' ? '编辑' : '预算审核中...'}}</div>
        <div class="linkbox" @click="contractApply" :class="{ 'grey': is_apply != 1 }">
          {{ fileList3[0].origin_name != '' ? '已签约' : (form.vendorContractArr.contract_no && form.vendorContractArr.contract_no != 'TBD' ? '已获取合同编号' : (is_apply == 1 ? '合同申请' : '等待编号')) }}
        </div>
      </div>  
      <div class="operater" v-if="!form.vendorContractArr && (mType == '2' ? NodeInclude('150') : NodeInclude('180')) && proStatus != 5 && form.contract_id != '-1'">
        <div class="linkbox" @click="showPurchase">点击选择供应商合同</div>
      </div>
      <template v-if="form.contract_id == '-1'">
        <div class="inblank">
          <p>该项目无需合同</p>
        </div>
      </template>      
      <template v-else>
        <ul>
          <li>
            <p>
              <label>供应商合同编号：</label>
              <a style="width: 100%;">
                <el-col :span="12">
                  {{ form.vendorContractArr.contract_no ? form.vendorContractArr.contract_no : '暂无合同编号' }}
                </el-col>
                <el-col :span="4">
                  <el-button round style="text-align: center;" @click="getPurchaseNo" :disabled="!canGetNo || !form.vendorContractArr"
                    v-if="(mType == '2' ? NodeInclude('148') : NodeInclude('174')) && proStatus != 5">自动获取</el-button>
                </el-col>
              </a>
            </p>
            <p>
              <label>合同类型：</label><a>{{ form.vendorContractArr ? dd.contract_type[form.vendorContractArr.contract_type] : '暂无' }}</a>
            </p>
            <p>
              <label>供应商合同时间：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.contract_start_time + '-' + form.vendorContractArr.contract_end_time : '暂无' }}</a>
            </p>
            <p v-if="form.vendorContractArr.contract_type != 2">
              <label>供应商合同金额：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.contract_amount : '暂无' }}</a>
            </p>
            <p v-if="form.vendorContractArr.contract_type != 2">
              <label>税率：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.tax_rate + '%' : '暂无' }}</a>
            </p>
            <p>
              <label>备注：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.info : '暂无' }}</a>
            </p>
            <p style="width: 150%;" v-if="form.vendorContractArr">
              <label>电子合同附件：</label>
              <template>
                <ul class="anlist">
                  <li v-for="(item, index) in fileList2" :key="index">
                    <div class="abox">
                      <!-- 选择文件 -->
                      <el-col :span="4" v-if="(mType == '2' ? NodeInclude('282') : NodeInclude('304')) && proStatus != 5">
                        <el-upload class="upload-demo" ref="upFile2" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                          :on-change="(arg) => uploadFile(arg, 'fileList2', 'upFile2', item, index)">
                          <el-button size="small" style="width: 80px;">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="20">
                          <el-col :span="18">
                            <div class="origin-name">{{ item.origin_name }}</div>
                          </el-col>
                          <el-col :span="2">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </div>
                    <el-button class="bbtn" v-if="(index === 0) && (mType == '2' ? NodeInclude('282') : NodeInclude('304')) && proStatus != 5" icon="el-icon-plus"
                      @click="addImage2(fileList2)" circle></el-button>
                    <el-button class="bbtn" v-if="index > 0 && (mType == '2' ? NodeInclude('282') : NodeInclude('304')) && proStatus != 5" icon="el-icon-minus"
                      @click="removeImage2(fileList2, index)" circle></el-button>
                  </li>
                </ul>
              </template>
            </p>
            <p style="width: 150%;" v-if="form.vendorContractArr">
              <label>盖章合同附件：</label>
              <template>
                <ul class="anlist">
                  <li v-for="(item, index) in fileList3" :key="index">
                    <div class="abox">
                      <!-- 选择文件 -->
                      <el-col :span="4"
                        v-if="(mType == '2' ? NodeInclude('149') : NodeInclude('173')) && (form.vendorContractArr.contract_no && form.vendorContractArr.contract_no != 'TBD') && proStatus != 5">
                        <el-upload class="upload-demo" ref="upFile3" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                          :on-change="(arg) => uploadFile(arg, 'fileList3', 'upFile3', item, index)">
                          <el-button size="small" style="width: 80px;">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <el-col :span="4" v-else-if="(mType == '2' ? NodeInclude('149') : NodeInclude('173')) && proStatus != 5">
                        <el-button size="small" style="width: 80px;" @click="showWrongFn">选择文件</el-button>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="20">
                          <el-col :span="18">
                            <div class="origin-name">{{
                              item.origin_name }}</div>
                          </el-col>
                          <el-col :span="2">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </div>
                    <el-button class="bbtn" v-if="(index === 0) && (mType == '2' ? NodeInclude('149') : NodeInclude('173')) && proStatus != 5" icon="el-icon-plus"
                      @click="addImage3(fileList3)" circle></el-button>
                    <el-button class="bbtn" v-if="index > 0 && (mType == '2' ? NodeInclude('149') : NodeInclude('173')) && proStatus != 5" icon="el-icon-minus"
                      @click="removeImage3(fileList3, index)" circle></el-button>
                  </li>
                </ul>
              </template>
            </p>
            <p v-if="form.vendorContractArr && proStatus != 5">
              <label></label>
              <a>
                <el-button type="primary" @click="updatePurchaseFn" style="margin-top: 18px;">确定上传</el-button>
              </a>
            </p>
          </li>
          <li>
            <p>
              <label>供应商合同名称：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.contract_name : '暂无' }}</a>
            </p>
            <p>
              <label v-if="form.vendorContractArr.contract_type == 3">所属合同：</label><a v-if="form.vendorContractArr.contract_type == 3">{{
                (form.vendorContractArr.parentContractArr.contract_no ? form.vendorContractArr.parentContractArr.contract_no : '暂无') }}</a>
            </p>
            <p>
              <label>创建合同时间：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.create_time : '暂无' }}</a>
            </p>
            <p></p>
            <p v-if="form.vendorContractArr.contract_type != 2">
              <label>税额：</label><a>{{ form.vendorContractArr ? form.vendorContractArr.tax : '暂无' }}</a>
            </p>
          </li>
        </ul>
      </template>
    </div>
    <!-- 支付计划 -->
    <div class="base1">
      <h3 class="ntitle">支付计划</h3>
      <div class="operater" v-if="proStatus != 5">
        <div class="linkline" @click="form.budget_status!= '2' && link(`/pay/plan?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&cid=${query.cid}&mType=${mType}`)" v-if="form.planList.length != 0 && (mType == '2' ? NodeInclude('145') : NodeInclude('177'))">{{form.budget_status != '2' ? '编辑' : '预算审核中...'}}</div>
        <div class="linkbox" @click="payCheckClick" v-if="(mType == '2' ? NodeInclude('138') : NodeInclude('166'))">支付审核</div>
        <div class="linkbox" @click="updatePayClick" v-if="(mType == '2' ? NodeInclude('139') : NodeInclude('165'))" style="margin-left: 15px;">更新支付状态</div>
      </div>    
      <template v-if="form.planList.length == 0">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="link(`/pay/plan?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&cid=${query.cid}&mType=${mType}`)" :disabled="!(mType == '2' ? NodeInclude('145') : NodeInclude('177')) || form.budget_status == '2' || proStatus == '5'"></el-button>
          <p>{{form.budget_status != '2' ? '该项目暂无支付计划，点击创建' : '预算审核中...'}}</p>
        </div>
      </template>   
      <template v-else>
        <ul v-for="(item, index) in form.planList" :key="index">
          <li>
            <p>
              <label>支付计划名称：</label><a>{{ item.plan_name }}</a>
            </p>
            <p>
              <label>计划支付时间：</label><a>{{ item.hope_pay_time }}</a>
            </p>
            <p>
              <label>支付时间：</label><a>{{ item.pay_time != '0000-00-00' ? item.pay_time : '暂无'}}</a>
            </p>
            <p>
              <label>支付凭证附件：</label>
              <template>
                <ul class="bbox">
                  <li v-for="(_it, _id) in item.atta_str" :key="_id">
                    <el-col :span="24" v-if="_it.origin_name">
                      <el-col :span="20">
                        <div class="origin-name">{{ _it.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="_it.httpFile" target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                    <el-col v-else>暂无附件</el-col>
                  </li>
                </ul>
              </template>
            </p>
            <p v-if="(mType == '2' ? NodeInclude('137') : NodeInclude('167')) && proStatus != 5">
              <label></label>
              <a>
                <el-button type="primary" @click="applyPayClick(item)" style="margin-top: 18px; ">
                  {{ item.plan_name == '结算' ? '申请结算' : '申请支付' }}
                </el-button>
              </a>
            </p>
          </li>
          <li>
            <p>
              <label>支付金额：</label><a>{{ item.plan_amount }}</a>
            </p>
            <p>
              <label>支付审核状态：</label>
              <el-tooltip class="item" effect="dark"
                :content="(item.pay_check_status == '1' || item.pay_check_status == '2') ? '暂无' : (item.pay_check_status == '3' ? (item.pay_check_info ? item.pay_check_info : '暂无') : (item.pay_check_reason ? item.pay_check_reason : '暂无'))"
                placement="top-start">
                <a>
                  <div class="circle-tag" :style="{ 'background': dd.pay_check_status_c[item.pay_check_status].color }"
                    v-if="item.pay_check_status">
                    <div class="word">{{ dd.pay_check_status_c[item.pay_check_status].word }}</div>
                  </div>
                </a>
              </el-tooltip>
            </p>
            <p>
              <label>支付状态：</label><a>{{ dd.pay_status[item.pay_status] }}</a>
            </p>
          </li>
        </ul>
      </template>
    </div>   
    <!-- 发票信息 -->
    <div class="base1">
      <h3 class="ntitle">发票信息</h3>
      <div class="operater" v-if="(mType == '2' ? NodeInclude('144') : NodeInclude('178')) && proStatus != 5">
        <div class="linkline" @click="form.budget_status!= '2' && link(`/pay/invoice?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&mType=${mType}&cid=${query.cid}`)" v-if="form.invoiceList.length != 0">编辑</div>
      </div>        
      <template v-if="form.invoiceList.length == 0">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="(form.budget_status!= '2' && form.vendorArr?.id) && link(`/pay/invoice?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&mType=${mType}&cid=${query.cid}`)" :disabled="!(mType == '2' ? NodeInclude('144') : NodeInclude('178')) || form.budget_status == '2' || proStatus == 5"></el-button>
          <p>{{form.vendorArr?.id ? (form.budget_status != '2' ? '该项目暂无发票信息，点击创建' : '预算审核中...') : '请先选择供应商再新增发票'}}</p>
        </div>
      </template>
      <template v-else>
        <ul v-for="(item, index) in form.invoiceList" :key="index">
          <li>
            <p>
              <label>发票代码：</label><a>{{ item.invoice_code ? item.invoice_code : '暂无' }}</a>
            </p>
            <p>
              <label>金额：</label><a>{{ item.invoice_amount ? item.invoice_amount : '暂无' }}</a>
            </p>
            <p>
              <label>发票附件：</label>
              <template>
                <ul class="bbox">
                  <li v-for="(_it, _id) in item.atta_str" :key="_id">
                    <el-col :span="24" v-if="_it.origin_name">
                      <el-col :span="20">
                        <div class="origin-name">{{ _it.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="_it.httpFile" target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                    <el-col v-else>暂无附件</el-col>
                  </li>
                </ul>
              </template>
            </p>
            <p>
              <label>发票状态：</label><a>{{ item.status == 1 ? '正常' : (item.status == 2 ? '作废' : '暂无') }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>发票号码：</label><a>{{ item.invoice_no ? item.invoice_no : '暂无' }}</a>
            </p>
            <p>
              <label>发票日期：</label><a>{{ item.invoice_date ? item.invoice_date : '暂无' }}</a>
            </p>
          </li>
        </ul>
      </template>
    </div>     
    <!-- 验收报告 -->
    <div class="base1">
      <h3 class="ntitle">采购验收</h3>
      <div class="operater" v-if="(mType == '2' ? NodeInclude('143') : NodeInclude('179')) && proStatus != 5">
        <div class="linkline" @click="form.budget_status!= '2' && link(`/pay/check?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&mType=${mType}&cid=${query.cid}`)" v-if="form.check_info || fileList1[0].origin_name">{{form.budget_status != '2' ? '编辑' : '预算审核中...'}}</div>
      </div>     
      <template v-if="!form.check_info && !fileList1[0].origin_name">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="form.budget_status!= '2' && link(`/pay/check?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&mType=${mType}&cid=${query.cid}`)" :disabled="!(mType == '2' ? NodeInclude('143') : NodeInclude('179'))|| form.budget_status == '2' || proStatus == 5"></el-button>
          <p>{{form.budget_status != '2' ? '暂未验收，点击创建' : '预算审核中...'}}</p>
        </div>
      </template> 
      <template v-else>
        <ul>
          <li>
            <p>
              <label>验收说明：</label><a>{{ form.check_info ? form.check_info : '暂无' }}</a>
            </p>
            <template v-if="form.assetList?.length != 0">
              <p v-for="(v, i) in form.assetList" :key="`asset_${i}`">
                <label>验收物品{{i + 1}}：</label>
                <a class="linkwrap normal" @click="link(`/asset/view?id=${v.id}`)">
                  <el-link>{{ v.asset_code }} - {{ v.asset_name }} - {{ v.secondary_name }}</el-link>
                </a>
              </p>
            </template>
            <p style="width: 150%;">
              <label>验收附件：</label>
              <template>
                <ul class="anlist">
                  <li v-for="(item, index) in fileList1" :key="index">
                    <div class="abox">
                      <!-- 选择文件 -->
                      <el-col :span="4" v-if="(mType == '2' ? NodeInclude('143') : NodeInclude('179')) && proStatus != 5">
                        <el-upload class="upload-demo" ref="upFile1" action="#" :limit="1" :show-file-list="false"
                          :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                          :on-change="(arg) => uploadFileMtype(arg, 'fileList1', 'upFile1', item, index)">
                          <el-button size="small" style="width: 80px;">选择文件</el-button>
                        </el-upload>
                      </el-col>
                      <!-- 文件预览及下载 -->
                      <template v-if="item.origin_name">
                        <el-col :span="20">
                          <el-col :span="18">
                            <div class="origin-name">{{
                              item.origin_name }}</div>
                          </el-col>
                          <el-col :span="2">
                            <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                              target="_blank">查看</el-link>
                          </el-col>
                        </el-col>
                      </template>
                    </div>
                    <el-button class="bbtn" v-if="(index === 0) && (mType == '2' ? NodeInclude('143') : NodeInclude('179')) && proStatus != 5" icon="el-icon-plus" @click="addImage1(fileList1)" circle></el-button>
                    <el-button class="bbtn" v-if="index > 0 && (mType == '2' ? NodeInclude('143') : NodeInclude('179')) && proStatus != 5" icon="el-icon-minus" @click="removeImage1(fileList1, index)" circle></el-button>
                  </li>
                </ul>
              </template>
            </p>
            <p v-if="(mType == '2' ? NodeInclude('143') : NodeInclude('179'))">
              <label></label>
              <a>
                <el-button type="primary" @click="updatePayFn" style="margin-top: 18px; ">更新验收附件</el-button>
              </a>
            </p> 
          </li>
          <li>
          </li>
        </ul>
      </template>
    </div>

    <el-dialog title="合同申请" :visible.sync="conShow" :close-on-click-modal="false" :show-close="false" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <span>请确认是否进行合同申请？</span>
          <span style="display: inline-block; font-size: 12px; margin-top: 20px; color: red;">!!合同申请前请再次确认合同金额是否正确，一旦获取合同编号，金额就不能再增加！</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleConApplyNo">取 消</el-button>
        <el-button type="primary" @click="handleConApply" :disabled="isDisabled">{{ buttonWord }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预算审核" :visible.sync="budgetCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>预算：</span>
          <span>{{ form.budget }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ form.service_type_name  }}</span>
        </li>
        <li>
          <span>采购事由：</span>
          <span style="white-space: pre-wrap;">{{ form.service_info }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ manager_name }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="bugetCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="预算审核：" prop="budget_status">
            <el-col :span="24">
              <el-radio-group v-model="bugetCheckForm.budget_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="bugetCheckForm.budget_status == '3'">
            <el-form-item label="" prop="budget_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="bugetCheckForm.budget_status == '4'">
            <el-form-item label="" prop="budget_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudgetCheck">确 定</el-button>
      </span>
    </el-dialog>  
    
    <el-dialog title="支付审核" :visible.sync="payCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0;">
        <el-form ref="payCheckForm" :model="payCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              <el-select v-model="payCheckForm.plan_id" placeholder="请选择" @change="planCheckChange" style="width:100%;">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in payCheckList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="计划支付金额：" prop="plan_amount">
            <el-col :span="24">
              {{ payCheckForm.plan_amount }}
            </el-col>
          </el-form-item>
          <el-form-item label="申请人：" prop="">
            <el-col :span="24">
              {{ manager_name }}
            </el-col>
          </el-form-item>
          <el-form-item label="审核：" prop="pay_check_status">
            <el-col :span="24">
              <el-radio-group v-model="payCheckForm.pay_check_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="payCheckForm.pay_check_status == '3'">
            <el-form-item label="" prop="pay_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="payCheckForm.pay_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="payCheckForm.pay_check_status == '4'">
            <el-form-item label="" prop="pay_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容" v-model="payCheckForm.pay_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handlePayCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付申请" :visible.sync="payShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>子项目名称：</span>
          <span>{{ form.projectSonArr.contract_name }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ form.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span style="white-space: pre-wrap;">{{ form.service_info }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ form.vendorArr ? form.vendorArr.vendor : '暂无' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ dd.pay_type[form.pay_type] }}</span>
        </li>
        <el-form ref="payForm" :model="payForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              {{ payForm.plan_name }}
            </el-col>
          </el-form-item>
          <el-form-item label="计划付款金额：" prop="apply_amount">
            <el-col :span="24">
              {{ payForm.apply_amount }}
            </el-col>
          </el-form-item>
          <el-form-item label="计划付款时间：" prop="hope_pay_time">
            <el-col :span="24">
              {{ payForm.hope_pay_time }}
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payShow = false">取 消</el-button>
        <el-button type="primary" @click="handleApply">申 请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商" :visible.sync="vendorShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商名称：" prop="vendor_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.vendor_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="vendorChange" clearable filterable>
              <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>      
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showNewVendor">没有相关供应商，点击下载《供应商登记表》</el-button>
      </span>
    </el-dialog> 

    <el-dialog title="下载供应商登记表" :visible.sync="newVendorShow" width="500px">
      <span>按照登记表补充供应商信息，联系Jaunty新增</span>
      <span slot="footer" class="dialog-footer">
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（个人）20230412.xlsx`" target="_blank">个人供应商</el-link>
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（公司）20230412.xlsx`" target="_blank">公司供应商</el-link>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商合同" :visible.sync="purchaseShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商合同：" prop="contract_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.contract_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="purchaseChange" clearable filterable>
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in purchaseList" :key="i" :disabled="v.beChoosed == '1'"></el-option>
            </el-select>
          </el-col>
        </el-form-item>      
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPurchase(vendorForm)">没有相关合同，新建供应商合同 </el-button>
      </span>      
    </el-dialog>
    
    <el-dialog title="温馨提示" :visible.sync="remindShow" width="500px">
      <ul class="aul" style="padding:0">
        <li>
          <span>请补全结算金额和计划支付时间后，再申请结算</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remindShow = false">取 消</el-button>
        <el-button type="primary" @click="link(`/pay/plan?id=${query.id}&kind=${mType == '2' ? '2' : '3'}&cid=${query.cid}&mType=${mType}`)">去补全</el-button>
      </span>    
    </el-dialog>
    
  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
import { timeFormat, thousands, antiThousands } from '@/utils/index.js'
export default {
  name: 'ahpayview',
  data() {
    return {
      nodeLimtList: [],
      mType: '',
      proStatus: '',//项目状态
      is_apply: '',
      manager_name: '',
      project_status: '',
      level: '',
      canGetNo: true,
      form: {
        projectArr: {
          client_company: '',
        },
        projectSonArr: {},
        vendorArr: {
          vendor: '',
        },
        vendorContractArr: {
          contract_name: '',
        },
        customerProjectArr: {},
        customerUserArr: {},
        pay_id: '',
        project_id: '',
        son_project_id: '',
        contract_name: '',
        contract_no: '',
        pay_info: '',
        vendor_id: '',
        budget: '',
        pay_type: '',
        service_type: '',
        service_info: '',
        contract_id: '',
        check_info: '',
        atta_str: '',
        invoiceList: [
          { invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }], }
        ],
        invoice_str: '',
        invoice_del: '',
        planList: [
          { plan_name: '', plan_amount: '', hope_pay_time: '', }
        ],
        plan_str: '',
        plan_del: '',
      },
      del_invoice_list: [],
      del_plan_list: [],
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList2: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList3: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],      
      del_atta_list2: [],      
      del_atta_list3: [],  
      //弹层部分   
      conShow: false,
      budgetCheckShow: false,
      bugetCheckForm: {
        option: 2,
        pay_id: '',
        budget_status: '4',
        budget_check_info: '',
        budget_check_reason: '',
      },
      payCheckShow: false,
      payCheckList: [],
      payCheckForm: {
        plan_id: '', 
        hope_pay_time: '', 
        plan_amount: '', 
        pay_check_status: '4', 
        pay_check_info: '',
        pay_check_reason: '',
      },
      payShow: false,
      payForm: {
        plan_id: '',
        plan_name: '',
        hope_pay_time: '',
        apply_amount: '',
      },
      host: '',
      vendorList: [],
      purchaseList : [],
      vendorShow: false,
      vendorForm: {}, //更改供应商
      newVendorShow: false,
      purchaseShow: false,
      remindShow: false,
      isDisabled: false, // 控制按钮是否禁用  
      countdown: 5, // 倒计时剩余时间  
      buttonWord: '5秒后方可确认', // 倒计时剩余时间  
      intervalId: null,
    }
  },
  created() {
    this.host = window.location.host.search('192') === -1 ? window.location.host : `devoa.minuteschina.com`
    this.query = this.$route.query
    this.mType = this.query.mType
    this.query.id && this.getDetail(this.query.id)
  },

  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //附件清单
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    //验收报告
    addImage1(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage1(arr, index) {
      if (arr[index].id) {
        this.del_atta_list1.push(arr[index].id);
      }
      console.log(this.del_atta_list1);
      arr = arr.splice(index, 1);
    },
    //供应商电子合同
    addImage2(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage2(arr, index) {
      if (arr[index].id) {
        this.del_atta_list2.push(arr[index].id);
      }
      console.log(this.del_atta_list2);
      arr = arr.splice(index, 1);
    },
    //供应商盖章合同
    addImage3(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage3(arr, index) {
      if (arr[index].id) {
        this.del_atta_list3.push(arr[index].id);
      }
      console.log(this.del_atta_list3);
      arr = arr.splice(index, 1);
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },  
    //选择文件 跟着mType走
    uploadFileMtype(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 4);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },  
    //更新供应商合同信息
    updatePurchaseFn() {
      //替换掉id为file_id
      let fileList2 = this.fileList2.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList3 = this.fileList3.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList2 = fileList2.concat(fileList3)
      let del_atta_list2 = this.del_atta_list2
      let del_atta_list3 = this.del_atta_list3
      const del_atta = del_atta_list2.concat(del_atta_list3)
      const $fileList = fileList2.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList2 = $fileList
      const tempForm = JSON.parse(JSON.stringify(this.form.vendorContractArr))
      delete tempForm.is_apply
      delete tempForm.status
      delete tempForm.projectArr
      delete tempForm.fileList
      this.$fly
        .post('apiPurchase_addUpdateContract.html', {
          contract_id: tempForm.id,
          ...tempForm,
          atta_str: JSON.stringify(fileList2),
          atta_del: del_atta.toString(),
          option: 2,
          mType: this.mType,
        })
        .then((res) => {
          if (res) {
            this.$message.success('供应商合同信息已更新')
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },  
    //更新支付清单和验收附件
    updatePayFn() {
      if (this.form.budget_status == '2') {
        this.$message.error('请等待预算审核结束后操作')
        return false
      }
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1= this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      const tempForm = JSON.parse(JSON.stringify(this.form))
      const { id, project_id, son_project_id, vendor_id } = tempForm
      this.$fly
        .post('apiProject_addUpdatePay.html', {
          pay_id: id,
          project_id,
          son_project_id,
          vendor_id,
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString(),
          option: 2,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success('支付详情已更新')
          }
          this.query.id && this.getDetail(this.query.id)
        })
    },  
    getPurchaseNo() {
      if (this.is_apply == 1) {
        this.$message.error('该合同暂未提交合同申请')
        return false
      }
      if (this.form.contract_type != '2') {
        if (this.form.budget_status != '3') {
          this.$message.error(`供应商合同无对应审核通过的预算`)
          return false
        }
        if (antiThousands(this.form.vendorContractArr.contract_amount) - antiThousands(this.form.budget) > 0) {
          this.$message.error(`供应商合同金额不能大于对应预算金额`)
          return false
        }          
      }    
      this.$fly
        .post('apiPurchase_getContractNo.html', {
          contract_id: this.form.vendorContractArr.id,
          mType: this.mType,
        })
        .then((res) => {
          this.form.vendorContractArr.contract_no = res.contractNo
          this.$message.success('供应商合同编号获取成功')
          this.canGetNo = false
        })
    },  
    showWrongFn() {
      this.$message.error('请先获取供应商合同编号')
    },     
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      return new Promise((resolve, reject) => {
        this.$fly
        .post('ApiAdministrative_getPayDetail.html', {
          pay_id: id,
          mType: this.mType,
        })
        .then((res) => {
          if (res) {
            let form = res.itemArr
            form.vendorTotalInvoice = thousands(form.vendorTotalInvoice)
            this.proStatus = form.projectArr.status
            this.manager_name = form.projectArr.manager_name
            //修改0000-00-00错误显示1899年情况
            const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
            form.invoiceList = form.invoiceList.map((item) => {
              item.invoice_date = timeFormat(item.invoice_date)
              item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
              return item
            })
            form.planList = form.planList.map((item) => {
              item.hope_pay_time = timeFormat(item.hope_pay_time)
              item.atta_str = item.planDetailList.length != 0 ? item.planDetailList[0].fileList : atta_str()
              return item
            })
            //清单附件
            this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
              delete item.project_id
              delete item.create_time
              item.flist = []
              return item
            })
            //验收附件 
            this.fileList1 = res.itemArr.fileList.filter(item => item.file_type == '2').map((item) => {
              delete item.project_id
              delete item.create_time
              item.flist = []
              return item
            })
            if (res.itemArr.vendorContractArr) {
              this.canGetNo = (res.itemArr.vendorContractArr.contract_no == '' || res.itemArr.vendorContractArr.contract_no == 'TBD') ? true : false
              //is_apply
              this.is_apply = form.vendorContractArr.is_apply
              console.log('is_apply:', this.is_apply);
            }
            // 供应商电子合同附件
            if (res.itemArr.vendorContractArr) {
              this.fileList2 = res.itemArr.vendorContractArr.fileList.filter(item => item.file_type == '1').map((item) => {
                item.flist = []
                return item
              })           
            }
            // 供应商盖章合同附件
            if (res.itemArr.vendorContractArr) {
              this.fileList3 = res.itemArr.vendorContractArr.fileList.filter(item => item.file_type == '2').map((item) => {
                item.flist = []
                return item
              })           
            }
            //防空情况
            if (this.fileList.length === 0) {
              this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
            }
            if (this.fileList1.length === 0) {
              this.fileList1 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
            }
            if (this.fileList2.length === 0) {
              this.fileList2 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
            }
            if (this.fileList3.length === 0) {
              this.fileList3 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
            }
            this.form = form
            setTimeout(() => {
              //权限
              this.level = store.state.level
              this.realName = store.state.realName
              console.log(this.level);
            }, 200);  
            resolve(res)               
          }     
          else {
            reject('error')
          }
        })
      })
    },
    //合同申请
    contractApply() {
      this.query.id && this.getDetail(this.query.id).then(() => {//先更新状态之后再打开弹层
        if (!this.fileList2[0].origin_name) {
          this.$message.error('请先上传电子合同')
          return false
        }      
        if (this.is_apply == 2) {
          this.$message.error('供应商合同申请已提交')
          return false
        }
        if (this.form.vendorContractArr.contract_no && this.form.vendorContractArr.contract_no != 'TBD') {
          this.$message.error('供应商合同已获取合同编号，不可提交合同申请')
          return false
        }
        if (this.form.contract_type != '2') {
          if (this.form.budget_status != '3') {
            this.$message.error(`供应商合同无对应审核通过的预算`)
            return false
          }
          if (antiThousands(this.form.vendorContractArr.contract_amount) - antiThousands(this.form.budget) > 0) {
            this.$message.error(`供应商合同金额不能大于对应预算金额`)
            return false
          }          
        }
        this.conShow = true
        if (!this.isDisabled) {
          this.isDisabled = true; // 禁用按钮  
          this.countdown = 5; // 设置倒计时为5秒  
          // 使用setInterval进行倒计时  
          this.intervalId = setInterval(() => {
            this.countdown--; // 倒计时减一  
            if (this.countdown <= 0) {
              clearInterval(this.intervalId); // 倒计时结束，清除定时器  
              this.isDisabled = false; // 重新启用按钮  
              this.countdown = 0; // 重置倒计时  
              this.buttonWord = `确 定`;
            }
            else {
              this.buttonWord = `${this.countdown}秒后方可确认`;
            }
          }, 1000); // 每秒执行一次  
        } else {
          this.buttonWord = `${this.countdown}秒后方可确认`;
        }
      })
    },
    handleConApplyNo() {
      this.conShow = false
      clearInterval(this.intervalId); // 倒计时结束，清除定时器  
      let tout = setTimeout(() => {
        this.isDisabled = false
        this.countdown = 5
        this.buttonWord = `${this.countdown}秒后方可确认`;
        clearInterval(tout);
      }, 500);
    },
    handleConApply() {
      if (!this.mType || this.mType == '1') {
        this.$message.error(`请退出页面重试`)
        return false
      }
      const tempForm = JSON.parse(JSON.stringify(this.form.vendorContractArr))
      delete tempForm.is_apply
      delete tempForm.status
      delete tempForm.projectArr
      delete tempForm.fileList
      this.$fly
        .post('apiPurchase_addUpdateContract.html', {
          contract_id: tempForm.id,
          ...tempForm,
          option: 2,
          //以上内容必填
          is_apply: 2,
          mType: this.mType,
        })
        .then((res) => {
          if (res) {
            this.conShow = false
            this.$message.success('供应商合同申请已提交')
            this.query.id && this.getDetail(this.query.id)
          }
        })
    }, 
    //预算审核
    showBudgetCheck() {
      const status = this.form.budget_status;
      if (status == '1') {
        this.$message.error('本条记录还未提交审核!')
        return false
      }
      if (this.level != 1) {
        if (status == '3' || status == '4') {
          this.$message.error('本条记录已审核!')
          return false
        }        
      }
      this.bugetCheckForm.pay_id = this.form.id
      this.budgetCheckShow = true
    },
    handleBudgetCheck() {
      let temp = JSON.parse(JSON.stringify(this.bugetCheckForm))
      this.$fly
        .post('apiProject_addUpdatePay.html', {
          ...temp,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.budgetCheckShow = false
          this.bugetCheckForm.budget_status = '4' //还原审核状态
          this.query.id && this.getDetail(this.query.id)
        })
    },
    //支付审核
    payCheckClick() {//支付审核
      if (this.form.budget_status != '3') {
        this.$message.error('请等待预算审核通过!')
        return false
      }
      this.payCheckList = JSON.parse(JSON.stringify(this.form.planList))
      if (this.level != 1) {
        this.payCheckList = this.payCheckList.map((item) => {//只取可以审核的订单
          return item.pay_check_status == '2' ? item : ''
        }).filter((s) => { return s })        
      }
      this.payCheckShow = true
      this.payCheckForm = { 
        plan_id: '', 
        hope_pay_time: '', 
        plan_amount: '', 
        pay_check_status: '4', 
        pay_check_info: '', 
        pay_check_reason: '', 
      }
    }, 
    planCheckChange() {
      this.payCheckList.forEach(item => {
        if (item.id == this.payCheckForm.plan_id) {
          this.payCheckForm = {
            ...this.payCheckForm,
            plan_amount: item.plan_amount,
            hope_pay_time: item.hope_pay_time,
            apply_amount: '',
          }
        }
      });
    },    
    handlePayCheck() {
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payCheckForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.payCheckShow = false
          this.payCheckForm.pay_check_status = '4' //还原审核状态
          this.payCheckForm.pay_check_info = '' //还原审核状态
          this.payCheckForm.pay_check_reason = '' //还原审核状态
          this.query.id && this.getDetail(this.query.id)
        })
    }, 
    //更新支付状态
    updatePayClick() {
      let toCheckList = []
      const planList = this.form.planList;
      for (let i = 0; i < planList.length; i++) {
        const {pay_check_status, id} = planList[i];
        if (pay_check_status == '3') {
          toCheckList.push(id)
        }
      }
      if (toCheckList.length == '0') {
        this.$message.error('暂无可以更新的支付计划!')
        return false
      }
      this.$router.push({
        path: '/project/pay',
        query: {
          id: this.form.id,
          cid: this.form.projectArr.id,
          kind: this.mType == '2' ? '2' : '3',
          mType: this.mType,
        },
      })
    }, 
    //申请支付
    applyPayClick(item) {
      if (!this.form.vendorArr) {
        this.$message.error('请先选择供应商!')
        return false
      }
      if (this.form.budget_status != '3') {
        this.$message.error('请等待预算审核通过!')
        return false
      }
      const { id, plan_amount, hope_pay_time, pay_check_status, plan_name } = item
      if (pay_check_status == '2') {
        this.$message.error('请勿重复申请!')
        return false
      }
      else if (pay_check_status == '3') {
        this.$message.error('该支付计划审核已通过！')
        return false
      }
      else if (pay_check_status == '4') {
        this.$message.error('该支付计划审核不通过，请修改计划重新提交!')
        return false
      }
      //预支特殊情况
      if (this.form.pay_type == '2' && plan_name == '结算') {
        if (this.form.planList[0].pay_status != '3') {
          this.$message.error('请先等待预支完成支付')
          return false
        }
        if (!hope_pay_time || hope_pay_time =='0000-00-00') {
          this.remindShow = true
          return false
        }
      }      
      this.payShow = true;
      this.payForm = {
        plan_id: id,
        plan_name,
        apply_amount: plan_amount,
        hope_pay_time: hope_pay_time,        
      }
    },
    handleApply() {
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.$message.success('申请成功')
          this.payShow = false;
          this.query.id && this.getDetail(this.query.id)
        })
    }, 
    //编辑预算
    editBudget() {
      if (this.form.budget_status == '2') {
        this.$message.error('请等待预算审核通过!')
        return false
      }
      this.$router.push({
        path: '/adminPay/add',
        query: {
          id: this.form.id,
          cid: this.form.projectArr.id,
          mType: this.mType,
        },
      })
    }, 
    //展示供应商
    showVendor() {
      // if (this.level == 6) {
      //   return false
      // }
      const { id, project_id, son_project_id, pay_type, vendorArr, budget_status, planList } = this.form
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        vendor: vendorArr.vendor || '',
        vendor_id: vendorArr.id || '',
        budget_status,
      }
      if (this.level != 1) {
        if (budget_status == '2') {
          this.$message.error('预算审核中不可更改供应商')
          return false
        }
        let flag = false
        if (planList) {
          planList.forEach((it)=> {
            if (it.pay_check_status == '3') {
              return flag = true
            }
          })
        }
        if (flag && this.vendorForm.contract_id) {
          this.$message.error('支付审核通过后不可修改供应商')
          return false
        }        
      }
      this.vendorShow = true
      this.getVendorList(pay_type)
    },
    vendorChange(v) {
      this.vendorList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor_id: item.id,
            vendor: item.vendor,
          }
        }
      })
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm))
      delete tempForm.budget_status
      delete tempForm.pay_type
      delete tempForm.vendor
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.vendorShow = false
      })
    },
    getVendorList(pay_type) {
      this.$fly
        .post('apiPurchase_getVendorList.html', {
          per_page: 5000,
          type: pay_type == '2' ? '2' : '' //预支只能是个人
        })
        .then((res) => {
          this.vendorList = pay_type == '2' ? res.itemList.filter(item => item.is_staff == '1') : res.itemList
        })    
    },
    //展示下载列表
    showNewVendor() {
      this.vendorShow = false
      this.newVendorShow = true
    },
    //展示供应商合同
    showPurchase() {
      // if (this.level == 6) {
      //   return false
      // }
      const { id, project_id, son_project_id, pay_type, budget, vendorArr, budget_status, vendorContractArr, planList } = this.form
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        budget,
        vendor: vendorArr.vendor || '',
        vendor_id: vendorArr.id || '',
        budget_status,
        client_contract_name: this.form.projectArr.contract_name,
        contract_id: vendorContractArr.id || '',
      }
      if (this.level != 1) {
        if (budget_status == '2') {
          this.$message.error('预算审核中不可更改供应商')
          return false
        }
        let flag = false
        if (planList) {
          planList.forEach((it)=> {
            if (it.pay_check_status == '3') {
              return flag = true
            }
          })
        }
        if (flag) {
          this.$message.error('支付审核通过后不可修改供应商合同')
          return false
        }        
      }
      this.purchaseShow = true
      this.getPurchaseList(this.vendorForm)
    },
    getPurchaseList(postData) {
      const {client_contract_name} = postData
      this.$fly
        .post('apiPurchase_getContractList.html', {
          per_page: 5000,
          client_contract_name,
          mType: this.mType,
        })
        .then((res) => {
          this.purchaseList = res.itemList
        })      
    }, 
    addPurchase(item) {
      this.$router.push({
        path: '/purchase/add',
        query: { 
          pid: item.project_id, 
          vid: item.vendor_id, 
          kind: 1, //不能改kind
          payid: item.pay_id, //更新支付计划合同选择
          mType: this.mType,
        },
      })
    },   
    purchaseChange(v) {
      this.purchaseList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor: item.vendor,
            vendor_id: item.vendor_id,
            contract_id: item.id,
            contract_amount: item.contract_amount,
            vendor_type: item.vendor_type,
          }
        }
      })
      if ((this.vendorForm.pay_type == '2' && this.vendorForm.is_staff != '1') && this.vendorForm.vendor_type == '1') {
        this.$message.error(`预支只能选择个人`)
        this.purchaseShow = false
        return false
      }
      if (antiThousands(this.vendorForm.contract_amount) - antiThousands(this.vendorForm.budget) > 0) {
        this.$message.error(`合同金额不能大于预算`)
        this.purchaseShow = false
        return false
      }
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm))
      delete tempForm.budget_status
      delete tempForm.pay_type
      delete tempForm.project_id
      delete tempForm.budget
      delete tempForm.is_staff
      delete tempForm.contract_amount
      delete tempForm.vendor_type
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.purchaseShow = false
      })
    },
    //更新支付计划的供应商
    updatePayVendor(tempForm) {
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiProject_addUpdatePay.html', {
            ...tempForm,
            option: 2,
            mType: this.mType,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$message.success('支付计划已更新')
              this.query.id && this.getDetail(this.query.id)
              resolve(res)
            }
            else {
              reject('fail')
            }
          })         
      })
    },           
  },
}
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: var(--card); /* 0819修改 */
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
      &.info-detail {
        color: #999;
        font: 12px/2 $font;
        white-space: pre-wrap;
      }
      &.pdou {
        span {
          &::after {
            content: ',';
            display: inline-block;
          }
          &:last-of-type {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }          

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .bbtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }

        }
      }
    }
  }
}

.aul.ulist {
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        cursor: pointer !important;

        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 14px;
        color: #606266;
      }
    }

    span {
      color: var(--text-1); /* 0819修改 */;
      font-size: 16px;
      padding: 0 5px;
    }
  }
}

.inblank {
  @extend %center;
  font: 14px/2 $font;
  color: #999;
  background: var(--bg-soft); /* 0819修改 */
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: var(--text-1); /* 0819修改 */;

      &:hover {
        &::after {
          display: block;
          content: '';
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0E0F22;
      background: #0E0F22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0E0F22, $alpha: 0.8);
      }
    }
  }
}

.circle-tag {
  position: relative;
  top: 11px;
  &:hover {
    .word {
      padding: 0 10px;
    }
  }
}

.dialog-download {
  border-radius: 12px;
  background: #231f20;
  font: 12px/2 $font;
  color: #fff;
  padding: 5px 20px;
  margin: 0 20px;
  &:hover {
    color: #fff;
    background: rgba($color: #0E0F22, $alpha: 0.8);
    &::after {
      display: none;
    }
  }
}
</style>
